import { render, staticRenderFns } from "./Page-Pictures.vue?vue&type=template&id=d2c5dce6&"
import script from "./Page-Pictures.vue?vue&type=script&lang=js&"
export * from "./Page-Pictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports